
import { ProtocolloPre2015DataResponse, ProtocolloPre2015Filters, ProtocolloPre2015Response } from "./dto";
import {  OldProtocolServiceImpl } from "./serviceImpl";

export interface OldProtocolService {
    
    // OLD PROTOCOL
    GetAllOldProtocols(filters: ProtocolloPre2015Filters): Promise<ProtocolloPre2015Response>
    GetOldProtocolById(id: string): Promise<ProtocolloPre2015DataResponse>

}

export function NewOldProtocolService(): OldProtocolService {
    return new OldProtocolServiceImpl();
}